module.exports = __webpack_public_path__ + "static/media/register-figure.1aa41f21.png";